export default __webpack_public_path__ + "static/media/profile.3f1d80d4.svg";